function locationRedirect(href) {
  /**
   * Bypass to not actually change the location in Headless Chrome for Karma
   * tests.
   */
  window.location.assign(href);
}

module.exports = { locationRedirect };



// WEBPACK FOOTER //
// ./static/js/v0/utilities/location-redirect.js